import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "todo_list_container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "list_wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "list_item" }
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "title_text" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "task_card_detail"
}
const _hoisted_13 = {
  key: 1,
  class: "task_card_detail"
}
const _hoisted_14 = {
  key: 2,
  class: "task_card_detail"
}
const _hoisted_15 = {
  key: 3,
  class: "task_card_detail"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "startBtn"
}
const _hoisted_18 = {
  key: 2,
  class: "startBtn"
}
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "task_card_detail"
}
const _hoisted_22 = {
  key: 1,
  class: "startBtn task_card_detail"
}
const _hoisted_23 = {
  key: 0,
  class: "task_card_doing"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "task_card_time" }
const _hoisted_26 = {
  key: 1,
  class: "task_card_exceed_time"
}
const _hoisted_27 = {
  key: 2,
  class: "task_card_exceed_time"
}
const _hoisted_28 = {
  key: 3,
  class: "task_card_detail"
}
const _hoisted_29 = {
  key: 4,
  class: "task_card_detail"
}
const _hoisted_30 = {
  key: 5,
  class: "task_card_detail"
}
const _hoisted_31 = {
  key: 1,
  class: "task_card_doing"
}
const _hoisted_32 = { class: "task_card_time" }
const _hoisted_33 = { class: "task_card_detail" }
const _hoisted_34 = {
  key: 2,
  class: "task_card_doing"
}
const _hoisted_35 = { class: "task_card_time" }
const _hoisted_36 = {
  key: 0,
  class: "task_card_detail"
}

import { computed } from 'vue'
import { useThemeImgs, useThemeColor } from '@/utils/theme'
import CardTitle from './CardTitle.vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

interface TItem {
  taskType: number
  taskId: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TodoList',
  props: {
    data: {},
    badgeNum: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "f343e826": (_unref(themeColor))
}))

const props = __props

const router = useRouter()

const skipHandle = (item: TItem) => {
  switch (item.taskType) {
    case 3:
      router.push('/examInfo?examId=' + item.taskId)
      break
    case 4:
      // '调查'
      router.push('/surveyInfo?investigationId=' + item.taskId)
      break
    case 0:
      // '培训'
      router.push('/trainingDetail?id=' + item.taskId)
      break
    case 8:
      // '练习'
      router.push('/examPractiseInfo?practiseId=' + item.taskId)
      break
    case 9:
      router.push('/faceDetail?faceId=' + item.taskId)
      break
    default:
      return ''
  }
}

const listData = computed(() => {
  try {
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const { t } = useI18n()

const getTaskTypeText = (taskType: number) => {
  switch (taskType) {
    case 3:
      return t('app_task_exam')
    case 4:
      return t('app_task_survey')
    case 0:
      return t('app_task_train')
    case 8:
      return t('app_task_practice')
    case 9:
      // 面授
      return t('app_task_offline_train')
    default:
      return ''
  }
}
// 标签状态 100:未开始,200:进行中,300:批阅中,400:已完成,500:已过期,600:已结束
const getTagStatusText = (tagStatus: number) => {
  switch (tagStatus) {
    case 100:
      return t('app_not_started')
    case 200:
      return t('app_ongoing')
    case 300:
      return t('app_reviewing')
    case 400:
      return t('app_done')
    case 500:
      return t('app_expired')
    case 600:
      return t('app_ended')
    default:
      return ''
  }
}

const themeImgs = useThemeImgs()
const themeColor = useThemeColor()
const bgImg = computed(() => themeImgs.value.index_bg)

const convertSeconds = (duration: number) => {
  if (duration > 60) {
    const days = Math.floor(duration / (3600 * 24))
    const hours = Math.floor((duration % (3600 * 24)) / 3600)
    const minutes = Math.floor((duration % 3600) / 60)
    let result = ''
    if (days > 0) {
      result += days + t('day_h5')
    }
    if (hours > 0) {
      result += hours + t('app_class_room_hour')
    }
    if (minutes > 0) {
      result += minutes + t('app_my_training_time_min')
    }
    return result
  } else {
    return 1 + t('app_my_training_time_min')
  }
}

return (_ctx: any,_cache: any) => {
  return (listData.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CardTitle, {
          title: __props.data.title,
          badgeNum: __props.badgeNum,
          skipPage: "/task"
        }, null, 8, ["title", "badgeNum"]),
        _createElementVNode("img", {
          class: "bg_img",
          src: bgImg.value
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.taskId,
              class: "list_item_wrapper",
              onClick: ($event: any) => (skipHandle(item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(item.taskName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(getTaskTypeText(item.taskType)), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["home_card_status", { active: item.tagStatus === 200 }])
                      }, _toDisplayString(getTagStatusText(item.tagStatus)), 3)
                    ]),
                    (!item.overdueStatus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (item.taskType === 3 && item.tagStatus !== 300)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_go_to_exam')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.taskType === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_go_to_participate')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.taskType === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_course_learn')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.taskType === 8)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (item.tagStatus === 100 || item.tagStatus === 200)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('go_practice')), 1))
                                  : (item.timeStatus === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('pc_person_view')), 1))
                                    : (item.tagStatus === 300 && item.isRepeat === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('pc_person_view')), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('go_practice_again')), 1))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.taskType === 9 && !item.countDownDuration)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (item.tagStatus === 200)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('app_go_to_participate')), 1))
                            : (item.tagStatus === 400 || item.tagStatus === 500)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('pc_person_view')), 1))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (item.taskType !== 8 && item.taskType !== 9 && item.tagStatus !== 100 && item.overdueStatus)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (
                  item.overdueStatus === 100 &&
                  item.countDownDuration &&
                  (item.tagStatus === 100 || item.tagStatus === 200)
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createTextVNode(_toDisplayString(_ctx.$t('remain_time')) + " ", 1),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(convertSeconds(item.countDownDuration)), 1)
                            ]))
                          : (item.overdueStatus === 200)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('has_exceed_time')), 1))
                            : (item.overdueStatus === 300)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('overdue_key')), 1))
                              : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
                        (item.taskType === 3 && item.tagStatus !== 300)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_go_to_exam')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.taskType === 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_go_to_participate')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.taskType === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('app_course_learn')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (
                item.taskType === 8 &&
                (item.tagStatus === 100 || item.tagStatus === 200) &&
                item.countDownDuration &&
                item.overdueStatus
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('remain_time')) + " ", 1),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(convertSeconds(item.countDownDuration)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('go_practice')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (item.taskType === 9 && item.countDownDuration)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('remain_time')) + " ", 1),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(convertSeconds(item.countDownDuration)), 1)
                        ]),
                        (item.tagStatus === 200)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t('app_go_to_participate')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})